import React from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import AddDeals from '../../components/addDeals'
import Breadcrum from '../../components/breadcrum'
import { FaArrowLeft } from 'react-icons/fa'

const AddIpo = () => {
  const navigate = useNavigate()
  const { id } = useParams() // For edit mode, get ID from URL params
  const location = useLocation()

  // Determine if this is edit mode based on URL or state
  const isEdit = location.pathname.includes('edit') || !!id

  return (
    <>
      <Breadcrum heading="Deals" subheading={isEdit ? 'Edit Ipo' : 'Add Ipo'} />
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex justify-center items-center bg-gray-500 p-2 text-white rounded sticky -top-[15px]"
      >
        <FaArrowLeft />
        &nbsp; Back
      </button>
      <AddDeals
        dealId={id}
        isEdit={isEdit}
        dealType="ipo" // Pass deal type for specific handling if needed
      />
    </>
  )
}

export default AddIpo
